/**
 * The Duplicates report's strings (piece 10; decision 1484), kept beside its
 * rules and spread into the one lookup in `strings.ts`, so `t()` stays the only
 * way a screen reads text. 🔨 This file imports nothing, because the lookup
 * imports it.
 */
export const DUPLICATE_STRINGS = {
  'duplicates.title': 'Duplicates',
  'duplicates.subtitle': 'Every pair of companies and of people the duplicate check flags, strongest match first',
  'duplicates.view.companies': 'Companies',
  'duplicates.view.people': 'People',
  'duplicates.empty.companies': 'No two companies look like one company.',
  'duplicates.empty.people': 'No two people look like one person.',
  'duplicates.pair.hint': 'Showing the one pair the import’s cleanup list named.',
  'duplicates.pair.all': 'Show Every Pair',
  'duplicates.pair.none': 'The duplicate check does not flag this pair now.',
  'duplicates.col.company': 'Company',
  'duplicates.col.person': 'Person',
  'duplicates.col.pair': 'Looks Like',
  'duplicates.col.reason': 'Why',
  'duplicates.col.flags': 'Flags',
  'duplicates.col.companies': 'Works At',
  'duplicates.col.sites': 'Sites',
  'duplicates.col.documents': 'Open Documents',
  'duplicates.col.created': 'Created',
  'duplicates.col.newerBy': 'Newer One Created By',
  'duplicates.col.action': 'Action',
  'duplicates.action.merge': 'Merge',
  'duplicates.action.refused': 'Cannot merge',
  'duplicates.createdBy.import': 'the Zoho Books import',
  'duplicates.createdBy.here': 'somebody here',
  'duplicates.flag.customer': 'Customer',
  'duplicates.flag.vendor': 'Vendor',
  'duplicates.flag.manufacturer': 'Manufacturer',
  'duplicates.none': 'none',
  'duplicates.mergeAllExact': 'Merge All Exact',
  'duplicates.mergeAllExact.count': 'exact company pairs are waiting',
  'duplicates.mergeAllExact.title': 'Merge Every Exact Pair',
  'duplicates.mergeAllExact.body': 'Every company pair with the same name once Inc, LLC and punctuation are set aside, and postal codes that do not disagree, goes as one approval request. Each pair merges into the survivor the report proposes. Nothing merges until the request is approved.',
  'duplicates.mergeAllExact.send': 'Send for Approval',
  'duplicates.mergeAllExact.none': 'No exact pair is waiting.',
  'duplicates.merge.titleCompany': 'Merge Two Companies',
  'duplicates.merge.titlePerson': 'Merge Two People',
  'duplicates.merge.lead': 'Choose the one that stays. Everything on the other moves to it: its sites, people, documents, notes and files. The other is gone, and its old address opens the one that stays.',
  'duplicates.merge.keep': 'Keep this one',
  'duplicates.merge.proposed': 'Proposed',
  'duplicates.merge.owner': 'Owner',
  'duplicates.merge.notSame': 'Not the Same',
  'duplicates.merge.notSameHint': 'Not the same takes the pair off this report for good.',
  'duplicates.merge.merged': 'Merged',
  'duplicates.merge.requested': 'Sent for approval',
  'duplicates.merge.dismissed': 'Taken off the report',
  'duplicates.merge.mergeAndNext': 'Merge and Next',
  'duplicates.merge.skip': 'Skip',
  'duplicates.merge.skipHint': 'Skip leaves the pair on the report and opens the next one.',
  'duplicates.merge.lastPair': 'That was the last pair on the report.',
  'duplicates.merge.fixed': 'Carries posted entries, so it stays',
  'duplicates.merge.refused': 'Neither can be merged away',
  'duplicates.merge.awaiting': 'Sent for approval',
  'duplicates.merge.flags': 'Flags',
  'duplicates.merge.worksAt': 'Works at',
  'duplicates.merge.sites': 'Open sites',
  'duplicates.merge.documents': 'Open documents',
  'duplicates.merge.created': 'Created',
  'duplicates.merge.createdBy': 'Created by',
  'duplicates.merge.why': 'Why they were paired',
  // Decision 1491: the per-field choice and the preview of what moves.
  // Decision 2501: the merge table's first column head, over the fields the two fill differently.
  'duplicates.merge.fieldsTitle': 'Field',
  'duplicates.merge.fieldsLead': 'Each row is a field the two fill differently. Pick the better value in its own cell; the one that stays keeps its value until you pick the other. A field only one fills is taken without asking.',
  'duplicates.merge.fieldsNone': 'No field is filled differently on the two.',
  'duplicates.merge.fieldsApproval': 'This merge goes to an approver. Each picked value rides the request and is written to the one that stays once the request is approved.',
  'duplicates.merge.movesTitle': 'What moves to the one that stays',
  'duplicates.merge.movesNone': 'None.',
  'duplicates.merge.movesLoading': 'Reading what moves…',
  'duplicates.merge.movesMore': 'more',
  'duplicates.merge.moves.documents': 'Documents',
  'duplicates.merge.moves.sites': 'Sites',
  'duplicates.merge.moves.people': 'People',
  'duplicates.merge.moves.employments': 'Employments',
  'duplicates.merge.moves.ended': 'ended',
  // Decision 7450 (T3092): Merge on the Companies and People lists' selection, a column per selected record.
  'duplicates.pairFault': '{losing} was not merged into {winning}: an unexpected fault stopped the merge, and the system error log holds it.',
  'duplicates.mergeSet.cap': 'Merge takes {count} records at most. Clear some, then press Merge again.',
  'duplicates.mergeSet.titleCompany': 'Merge Companies',
  'duplicates.mergeSet.titlePerson': 'Merge People',
  'duplicates.mergeSet.lead': 'Choose the one that stays. Everything on each of the others moves to it: its sites, people, documents, notes and files. The others are gone, and their old addresses open the one that stays.',
  'duplicates.mergeSet.fieldsLead': 'Each row is a field the records fill differently. Pick the better value in its own cell; the one that stays keeps its value until you pick another. A field only one fills is taken without asking.',
  'duplicates.mergeSet.fieldsNone': 'No field is filled differently on these records.',
  'duplicates.mergeSet.approval': 'This merge goes to an approver as one request for the whole set.',
  'duplicates.mergeSet.fieldsApproval': 'This merge goes to an approver as one request for the whole set. Each picked value rides it and is written to the one that stays once the request is approved.',
  'duplicates.mergeSet.twoApprovers': 'This merge goes to two approvers as two requests: each person who works here to HR, and the rest to Sales. Each picked value rides the request of the record it was picked from.',
  'duplicates.mergeSet.requestedTwo': 'Sent for approval as two requests, one to HR and one to Sales.',
  'duplicates.mergeSet.fixedBlocked': 'A record that carries posted entries cannot be merged away. Keep it, or clear it from the selection.',
  'duplicates.mergeSet.loading': 'Reading the records…',
  'duplicates.mergeSet.merged': 'merged into the one that stays.',
  'duplicates.mergeSet.partial': 'Not merged, each with its reason:',
  // Decision 7470 (T3094): Merge on the Items list's selection, an item's facts in its column and what moves from it.
  'duplicates.mergeSet.titleItem': 'Merge Items',
  'duplicates.mergeSet.leadItem': 'Choose the one that stays. Everything on each of the others moves to it: its stock, document lines, bill of materials lines, supplier rows, prices and cost history. The others are gone, and their old links open the one that stays.',
  'duplicates.mergeSet.cannotMerge': 'Cannot merge',
  'duplicates.mergeSet.itemWithheld': 'Fields you may not see keep the value of the one that stays:',
  'duplicates.mergeSet.itemWithheldPick': 'A merge cannot take {fields} from another item, because you may not see it. The one that stays keeps its own.',
  'duplicates.merge.itemType': 'Type',
  'duplicates.merge.itemUnit': 'Unit of sale',
  'duplicates.merge.itemOnHand': 'On hand',
  'duplicates.merge.itemLines': 'Document lines',
  'duplicates.merge.moves.stock': 'Stock',
  'duplicates.merge.moves.documentLines': 'Document lines',
  'duplicates.merge.moves.bomLines': 'Bill of materials lines',
  'duplicates.merge.moves.suppliers': 'Supplier rows',
  'duplicates.merge.moves.prices': 'Prices and cost history',
  'duplicates.merge.moves.onHand': 'on hand',
  'duplicates.merge.moves.priceSheet': 'Price sheet',
  'history.audit.mergeFieldsTaken': 'Values taken from the record merged into it',
  'history.audit.itemMerged': 'Item merged into this one',
  // Decision 1920: a site the merge folds into the survivor's own at the same address, and the Sites tile's fold.
  'duplicates.merge.moves.joins': 'joins',
  'history.audit.siteFolded': 'Sites folded into one',
  'sites.former': 'Former sites',
  'sites.former.show': 'Show',
  'sites.former.hide': 'Hide',
  'sites.overlap': 'These two rows overlap',
  'sites.fold.into': 'Fold into',
  'sites.fold.title': 'Fold into One Site',
  'sites.fold.hint': 'The two rows become one site at this address, from the earlier start to the later end. Everything that names the row folded away, documents, people and work, moves to the one that stays, and the row folded away is removed.',
  'sites.fold.confirm': 'Fold',
  'sites.fold.done': 'The two sites are one.',
  // Decision 7390 (T3076): the gold badge on a site that holds a Tax Exempt certificate, and the words of its hover.
  'sites.taxExempt.title': 'Tax Exempt certificate',
  'sites.taxExempt.effective': 'effective',
  'sites.taxExempt.expires': 'expires',
} as const;
